import { Modal, ModalBlock } from '@sb1/ffe-modals-react';
import { BodyText } from '../../components/typography/Heading';
import { Heading2 } from '@sb1/ffe-core-react';
import Image from '../../components/image/Image';
import styles from './reward-modal.module.less';
import { RewardButtons } from './RewardButtons';

const RewardModal = ({ title, imageSrc, description, modalRef, buttonConfig }) => {
    return (
        <Modal ref={modalRef}>
            <ModalBlock>
                <Heading2 className={styles.title}>{title}</Heading2>
                <div className={styles.modalBlock}>
                    {imageSrc && <Image className={styles.modalImage} src={imageSrc} />}
                    <BodyText>{description}</BodyText>
                    <RewardButtons
                        wrapperClassName={styles.rewardButtons}
                        {...buttonConfig}
                        onAfterClick={() => {
                            modalRef.current.close();
                        }}
                    />
                </div>
            </ModalBlock>
        </Modal>
    );
};

export default RewardModal;
